import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito experiencia previa?',
  answer: 'No, el curso está diseñado para principiantes. Te enseñamos desde cero con videos paso a paso y fórmulas exactas.'
}, {
  question: '¿Cuánto necesito invertir para empezar?',
  answer: 'La inversión inicial en materiales es mínima (menos de $5,000). Podés empezar con poco y crecer a medida que vendés.'
}, {
  question: '¿Cuánto tiempo tarda en aprender?',
  answer: 'En menos de 24 horas podés hacer tus primeras tabletas profesionales. El curso es práctico y directo al punto.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Tenés 72 horas de garantía. Si no estás satisfecha, te devolvemos el 100% de tu inversión sin preguntas.'
}, {
  question: '¿Incluye la lista de proveedores?',
  answer: 'Sí, te damos acceso a proveedores confiables y económicos para que no pierdas tiempo buscando.'
}, {
  question: '¿Cuándo puedo empezar?',
  answer: 'Inmediatamente después del pago. Recibís acceso instantáneo al curso completo y podés empezar hoy mismo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-58">
      <div className="container mx-auto max-w-3xl" data-id="element-59">
        <div className="text-center mb-12" data-id="element-60">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-61">
            Preguntas frecuentes
          </h2>
          <p className="text-lg text-[#6B6B6B]" data-id="element-62">
            Todo lo que necesitás saber antes de empezar
          </p>
        </div>

        <div className="space-y-4" data-id="element-63">
          {faqs.map((faq, index) => <article key={index} className="backdrop-blur-sm bg-white/80 rounded-2xl border border-white/20 shadow-sm overflow-hidden" data-id="element-64">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50/50 transition-colors duration-200" aria-expanded={openIndex === index} data-id="element-65">
                <h3 className="text-lg font-bold text-gray-900 pr-4" data-id="element-66">
                  {faq.question}
                </h3>
                <ChevronDownIcon className={`w-5 h-5 text-[#FF4DB8] flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-67" />
              </button>
              {openIndex === index && <div className="px-6 pb-6" data-id="element-68">
                  <p className="text-[#6B6B6B] leading-relaxed" data-id="element-69">{faq.answer}</p>
                </div>}
            </article>)}
        </div>
      </div>
    </section>;
}